import { render, staticRenderFns } from "./BonoNuevoRiesgo.vue?vue&type=template&id=71d87862"
import script from "./BonoNuevoRiesgo.vue?vue&type=script&lang=js"
export * from "./BonoNuevoRiesgo.vue?vue&type=script&lang=js"
import style0 from "./BonoNuevoRiesgo.vue?vue&type=style&index=0&id=71d87862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports